import { render } from "./Role.vue?vue&type=template&id=639bf2da"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cid_app/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__